import { cn } from "admin-ui/utils/cn"
import { IconProps } from "."

export default function CircleTrash({
  className,
  transform,
  ...reset
}: Readonly<IconProps>) {
  return (
    <svg
      width="80"
      height="81"
      viewBox="0 0 80 81"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={cn("h-6 w-6", className)}
      transform={transform}
      {...reset}
    >
      <path
        d="M80 40.5022C80 43.5622 79.528 46.8576 79.056 49.6822C78.5841 51.5653 78.1121 53.213 77.4041 54.8607C73.3923 65.2176 65.1327 73.6915 54.7493 77.6931C53.8053 77.9284 53.3333 78.3992 52.3894 78.6346C48.3776 79.8115 44.3658 80.5177 40.118 80.5177C17.9351 80.5177 0 62.6284 0 40.5022C0 18.3759 17.9351 0.486642 40.118 0.486642C62.0649 0.251257 80 18.3759 80 40.5022Z"
        fill="url(#paint0_linear_6038_160063)"
      />
      <path
        d="M52.7217 34.9463C53.0871 34.9463 53.4186 35.1056 53.6807 35.375C53.9249 35.6628 54.0484 36.0208 54.0127 36.3984C54.0108 36.547 53.0351 48.8839 52.4775 54.0801C52.1281 57.2719 50.0698 59.2095 46.9834 59.2627C44.6104 59.3159 42.2907 59.335 40.0068 59.335C37.5821 59.335 35.2109 59.3159 32.9092 59.2627C29.9262 59.1912 27.8668 57.2187 27.5352 54.0801C26.9616 48.8653 26.003 36.5456 25.9834 36.3984C25.9656 36.0208 26.087 35.6628 26.333 35.375C26.5754 35.1056 26.9248 34.9464 27.292 34.9463H52.7217ZM43.7852 22.668C45.4058 22.668 46.8533 23.799 47.2725 25.4121L47.5723 26.751C47.8148 27.8417 48.7601 28.6133 49.8477 28.6133H55.1934C55.9064 28.6135 56.5 29.2056 56.5 29.959V30.6553C56.5 31.3903 55.9064 32.0008 55.1934 32.001H24.8086C24.0937 32.0009 23.5 31.3904 23.5 30.6553V29.959C23.5 29.2056 24.0937 28.6134 24.8086 28.6133H30.1543C31.24 28.6132 32.1853 27.8418 32.4297 26.7529L32.709 25.502C33.1441 23.7989 34.5763 22.668 36.2148 22.668H43.7852Z"
        fill="#52525B"
      />
      <defs>
        <linearGradient
          id="paint0_linear_6038_160063"
          x1="40"
          y1="66.3185"
          x2="12.6361"
          y2="6.84863"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#E4E4E7" />
          <stop offset="1" stopColor="#F4F4F5" />
        </linearGradient>
      </defs>
    </svg>
  )
}
